(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("gpCTg", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", function () { return $bf2d25f8ffb0a7d4$export$c17561cb55d4db30; });
$parcel$export(module.exports, "make", function () { return $bf2d25f8ffb0a7d4$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $gCzsf = parcelRequire("gCzsf");
function $bf2d25f8ffb0a7d4$var$QuickViewTabs$ProgressBar(Props) {
    var className = Props.className;
    var style = Props.style;
    var mediaId = Props.mediaId;
    var index = Props.index;
    var autoplayOpt = Props.autoplay;
    var autoplayPausedOpt = Props.autoplayPaused;
    var progress = Props.progress;
    var progressSpeed = Props.progressSpeed;
    var setProgressRef = Props.setProgressRef;
    var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
    var autoplayPaused = autoplayPausedOpt !== undefined ? autoplayPausedOpt : false;
    var match = $g85JO.useState(function() {
        return progress;
    });
    var setProgress = match[1];
    var progress$1 = match[0];
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setForceEndTransition = match$1[1];
    var forceEndTransition = match$1[0];
    var setter = $g85JO.useCallback(function(value) {
        $iv6Yc._1(setProgress, function(param) {
            return value;
        });
    }, [
        setProgress
    ]);
    $g85JO.useEffect(function() {
        if (setProgressRef !== undefined) setProgressRef.current = $i7mYY.concat(setProgressRef.current, [
            setter
        ]);
        return function(param) {
            if (setProgressRef !== undefined) {
                setProgressRef.current = $i7mYY.keep(setProgressRef.current, function(fn) {
                    return fn !== setter;
                });
                return;
            }
        };
    }, [
        setProgressRef,
        setter
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setForceEndTransition, function(param) {
            return true;
        });
    }, [
        progressSpeed,
        mediaId,
        index
    ]);
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$setTimeout = match$2.setTimeout;
    $g85JO.useEffect(function() {
        $$setTimeout(function(param) {
            $iv6Yc._1(setForceEndTransition, function(param) {
                return false;
            });
        }, 16);
    }, [
        forceEndTransition
    ]);
    var translateX = autoplay ? progress$1 !== undefined ? progressSpeed !== undefined ? "0%" : String(progress$1 - 100 | 0) + "%" : progressSpeed !== undefined ? "0%" : "-100%" : "0%";
    var translateX$1 = forceEndTransition ? "-100%" : translateX;
    var translateX$2 = autoplayPaused ? "-99%" : translateX$1;
    var transitionDuration = autoplay && progressSpeed !== undefined ? String(progressSpeed) + "ms" : "0ms";
    var classNameMod = autoplay && progressSpeed !== undefined && !forceEndTransition ? "transition-transform ease-linear" : "transition-none duration-0";
    var className$1 = $1TRFX.make([
        $2whNH.getWithDefault(className, ""),
        $ezf3v.prefix("w-full"),
        $ezf3v.prefix(classNameMod)
    ]);
    var progressStyle = {
        transitionDuration: transitionDuration,
        transform: "translate3d(" + translateX$2 + ", 0, 0)"
    };
    var style$1 = style !== undefined ? Object.assign({}, progressStyle, $loT9g.valFromOption(style)) : progressStyle;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: className$1,
        style: style$1
    });
}
$bf2d25f8ffb0a7d4$var$QuickViewTabs$ProgressBar.displayName = "QuickViewTabs.ProgressBar";
var $bf2d25f8ffb0a7d4$export$c17561cb55d4db30 = {
    make: $bf2d25f8ffb0a7d4$var$QuickViewTabs$ProgressBar
};
function $bf2d25f8ffb0a7d4$var$QuickViewTabs(Props) {
    var mediaId = Props.mediaId;
    var index = Props.index;
    var total = Props.total;
    var onClick = Props.onClick;
    var alignOpt = Props.align;
    var autoplayOpt = Props.autoplay;
    var autoplayPausedOpt = Props.autoplayPaused;
    var progress = Props.progress;
    var progressSpeed = Props.progressSpeed;
    var setProgressRef = Props.setProgressRef;
    var positionOpt = Props.position;
    var sizeOpt = Props.size;
    var styleOpt = Props.style;
    var enableTruncationOpt = Props.enableTruncation;
    var isMobileOpt = Props.isMobile;
    var paddingOpt = Props.padding;
    var gradientOpt = Props.gradient;
    var dataTestId = Props.dataTestId;
    var align = alignOpt !== undefined ? alignOpt : "top";
    var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
    var autoplayPaused = autoplayPausedOpt !== undefined ? autoplayPausedOpt : false;
    var position = positionOpt !== undefined ? positionOpt : "center";
    var size = sizeOpt !== undefined ? sizeOpt : "lg";
    var style = styleOpt !== undefined ? styleOpt : "line";
    var enableTruncation = enableTruncationOpt !== undefined ? enableTruncationOpt : false;
    var isMobile = isMobileOpt !== undefined ? isMobileOpt : false;
    var padding = paddingOpt !== undefined ? paddingOpt : true;
    var gradient = gradientOpt !== undefined ? gradientOpt : false;
    var truncateSize = isMobile ? 4 : 10;
    var truncateThreshold = isMobile ? 8 : 20;
    var enableTruncation$1 = enableTruncation && total >= truncateThreshold;
    var items = $i7mYY.range(0, total - 1 | 0);
    var autoplay$1 = autoplayPaused ? false : autoplay;
    var isWithinRange = function isWithinRange(i, offset) {
        var range = truncateSize + offset | 0;
        var leftRemainder = Math.max(range - index | 0, 0);
        var rightRemainder = Math.min((total - index | 0) - range | 0, 0);
        var diff = i - index | 0;
        if (diff < 0) return diff >= (Math.imul(-1, range) + rightRemainder | 0);
        else if (diff > 0) return (diff - range | 0) < leftRemainder;
        else return true;
    };
    var verticalPositionStyle = typeof align === "object" ? align.NAME === "arbTop" ? {
        top: $ezf3v.intToPx(align.VAL)
    } : {
        bottom: $ezf3v.intToPx(align.VAL)
    } : align === "top" ? {
        top: "0px"
    } : {
        bottom: "0px"
    };
    var items$1 = $g85JO.useMemo(function() {
        return $i7mYY.map($i7mYY.keep(items, function(i) {
            if (isWithinRange(i, 6)) return true;
            else return !enableTruncation$1;
        }), function(i) {
            var size$1 = !isWithinRange(i, 3) && enableTruncation$1 ? "zero" : !isWithinRange(i, 0) && enableTruncation$1 ? "xs" : size;
            var itemPositionStyle;
            var exit = 0;
            exit = typeof align === "object" ? align.NAME === "arbTop" ? 1 : 2 : align === "top" ? 1 : 2;
            switch(exit){
                case 1:
                    itemPositionStyle = {
                        top: "6px"
                    };
                    break;
                case 2:
                    itemPositionStyle = {
                        bottom: "6px"
                    };
                    break;
            }
            if (size$1 === undefined) return null;
            var sizeCn = size$1 === "zero" ? style === "circle" ? "w-0 h-0" : "w-0 h-1" : size$1 === "lg" ? style === "circle" ? "w-4 h-4" : "w-20 h-1" : size$1 === "sm" ? style === "circle" ? "w-2 h-2" : "w-10 h-1" : size$1 === "xs" ? style === "circle" ? "w-1 h-1" : "w-2 h-1" : style === "circle" ? "w-4 h-4" : "w-full h-1";
            var tmp;
            if (i === index) {
                var tmp$1 = {
                    className: $ezf3v.prefix($1TRFX.make([
                        "absolute bg-white",
                        sizeCn
                    ])),
                    index: index,
                    autoplay: autoplay$1,
                    autoplayPaused: autoplayPaused
                };
                if (mediaId !== undefined) tmp$1.mediaId = mediaId;
                if (progress !== undefined) tmp$1.progress = progress;
                if (progressSpeed !== undefined) tmp$1.progressSpeed = progressSpeed;
                if (setProgressRef !== undefined) tmp$1.setProgressRef = $loT9g.valFromOption(setProgressRef);
                tmp = /*#__PURE__*/ $g85JO.createElement($bf2d25f8ffb0a7d4$var$QuickViewTabs$ProgressBar, tmp$1);
            } else tmp = i < index ? /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "absolute bg-white transition-none duration-0 w-full",
                    sizeCn
                ]))
            }) : null;
            return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                dataActive: i === index,
                dataTestId: "qv-tab-item",
                children: /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix($1TRFX.make([
                        "relative",
                        "duration-200 transition-all",
                        "no-touch-highlight",
                        "pointer-events-auto",
                        size$1 !== "zero" ? "mr-1" : "mr-0",
                        $2whNH.isSome(onClick) ? "cursor-pointer" : "",
                        sizeCn
                    ])),
                    style: itemPositionStyle,
                    onClick: function onClick1(param) {
                        if (onClick !== undefined) return $iv6Yc._1(onClick, i);
                    }
                }, /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("w-full h-8 absolute left-1/2 right-1/2 mt-2 transform -translate-x-1/2 -translate-y-1/2")
                }), /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix($1TRFX.make([
                        "absolute w-full rounded-full overflow-hidden",
                        "bg-white",
                        i === index ? "bg-opacity-60" : "bg-opacity-25",
                        sizeCn
                    ])),
                    style: itemPositionStyle
                }, tmp)),
                key: String(i)
            });
        });
    }, [
        [
            total,
            index,
            size
        ],
        mediaId
    ]);
    var renderGradient = function renderGradient(param) {
        var verticalPositionCn = typeof align === "object" ? align.NAME === "arbTop" ? "top-0" : "bottom-0" : align === "top" ? "top-0" : "bottom-0";
        if (!gradient) return null;
        var tmp;
        if (typeof align === "object") {
            var variant = align.NAME;
            tmp = variant === "arbTop" || variant === "arbBottom" ? align.VAL : 0;
        } else tmp = 0;
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute w-full left-0 pointer-events-none",
                verticalPositionCn
            ])),
            style: {
                background: typeof align === "object" ? align.NAME === "arbTop" ? "linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 60%)" : "linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 80%)" : align === "top" ? "linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 60%)" : "linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 80%)",
                height: $ezf3v.intToPx(144 + tmp | 0)
            }
        });
    };
    var tmp = {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-1 justify-center max-w-full")
        }, items$1)
    };
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, renderGradient(undefined), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute right-0",
            "left-0",
            position === "right" ? padding ? "pr-3" : "" : size === "full" ? padding ? "px-6" : "" : isMobile ? padding ? "px-6" : "" : position === "center" && padding ? "px-32" : ""
        ])),
        style: verticalPositionStyle
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp)));
}
$bf2d25f8ffb0a7d4$var$QuickViewTabs.displayName = "QuickViewTabs";
var $bf2d25f8ffb0a7d4$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($bf2d25f8ffb0a7d4$var$QuickViewTabs);
 /* make Not a pure module */ 
});

parcelRegister("e2Ecw", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a3906faa49f8addf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $jjSTi = parcelRequire("jjSTi");

var $aSJcu = parcelRequire("aSJcu");
function $a3906faa49f8addf$var$ExpandSequence(Props) {
    var isOpenOpt = Props.isOpen;
    var animateOpt = Props.animate;
    var crossFadeOpt = Props.crossFade;
    var topOffset = Props.topOffset;
    var getSourceElOpt = Props.getSourceEl;
    var allowPhaseChange = Props.allowPhaseChange;
    var onPhaseChange = Props.onPhaseChange;
    var onTouchEnd = Props.onTouchEnd;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var renderForegroundOpt = Props.renderForeground;
    var autoHideSourceElOpt = Props.autoHideSourceEl;
    var zIndex = Props.zIndex;
    var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
    var animate = animateOpt !== undefined ? animateOpt : true;
    var crossFade = crossFadeOpt !== undefined ? crossFadeOpt : false;
    var getSourceEl = getSourceElOpt !== undefined ? getSourceElOpt : function getSourceEl(param) {};
    var renderForeground = renderForegroundOpt !== undefined ? renderForegroundOpt : function renderForeground(param, param$1) {
        return null;
    };
    var autoHideSourceEl = autoHideSourceElOpt !== undefined ? autoHideSourceElOpt : true;
    var match = $aSJcu.use(undefined);
    var breakpoint = match.breakpoint;
    var getBoundingClientRect = function getBoundingClientRect(param) {
        return $2whNH.map($iv6Yc._1(getSourceEl, undefined), function(el) {
            return el.getBoundingClientRect();
        });
    };
    var domRect = getBoundingClientRect(undefined);
    var rect = $2whNH.map(domRect, function(domRect) {
        return {
            x: domRect.x | 0,
            y: domRect.y | 0,
            width: domRect.width | 0,
            height: domRect.height | 0
        };
    });
    var enterDuration;
    switch(breakpoint){
        case /* Xs */ 0:
        case /* Sm */ 1:
            enterDuration = 250;
            break;
        case /* Md */ 2:
            enterDuration = 300;
            break;
        case /* Lg */ 3:
            enterDuration = 350;
            break;
        case /* Xl */ 4:
            enterDuration = 400;
            break;
    }
    var exitDuration;
    switch(breakpoint){
        case /* Xs */ 0:
        case /* Sm */ 1:
            exitDuration = 200;
            break;
        case /* Md */ 2:
            exitDuration = 250;
            break;
        case /* Lg */ 3:
            exitDuration = 300;
            break;
        case /* Xl */ 4:
            exitDuration = 350;
            break;
    }
    var phases = rect !== undefined ? animate ? isOpen ? [
        [
            /* Hidden */ 0,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: rect
            },
            crossFade ? 50 : 0
        ],
        [
            /* MinimalFullscreen */ 1,
            enterDuration
        ],
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* CompleteFullscreen */ 2,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: rect
            },
            exitDuration
        ],
        [
            /* Hidden */ 0,
            crossFade ? 50 : 0
        ]
    ] : isOpen ? [
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* Hidden */ 0,
            0
        ]
    ] : animate ? isOpen ? [
        [
            /* MinimalFullscreen */ 1,
            0
        ],
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* CompleteFullscreen */ 2,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }
            },
            exitDuration
        ],
        [
            /* Hidden */ 0,
            crossFade ? 50 : 0
        ]
    ] : isOpen ? [
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* Hidden */ 0,
            0
        ]
    ];
    var style = {
        height: topOffset > 0 ? "calc(100% - " + $ezf3v.intToPx(topOffset) + ")" : "100%",
        left: "0",
        position: "fixed",
        top: $ezf3v.intToPx(topOffset),
        width: "100%",
        zIndex: $2whNH.getWithDefault(zIndex, "2147483647")
    };
    var match$1 = $jjSTi.useSequence(onPhaseChange, allowPhaseChange, phases);
    var phase = match$1[0];
    $g85JO.useLayoutEffect(function() {
        return function(param) {};
    }, [
        phase,
        autoHideSourceEl
    ]);
    if (phase === 0) return null;
    var tmp = {
        style: style
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, $iv6Yc._2(renderForeground, phase, match$1[1]));
}
$a3906faa49f8addf$var$ExpandSequence.displayName = "ExpandSequence";
var $a3906faa49f8addf$export$dd44f18ab656f3bb = $a3906faa49f8addf$var$ExpandSequence;
 /* react Not a pure module */ 
});
parcelRegister("jjSTi", function(module, exports) {

$parcel$export(module.exports, "useSequence", function () { return $e10a5edc54bb3b9f$export$574cda3fe44b1d9e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $d8lRc = parcelRequire("d8lRc");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $3QSSt = parcelRequire("3QSSt");

var $4Q2zg = parcelRequire("4Q2zg");
function $e10a5edc54bb3b9f$export$574cda3fe44b1d9e(onPhaseChangeOpt, allowPhaseChangeOpt, timedPhases) {
    var onPhaseChange = onPhaseChangeOpt !== undefined ? onPhaseChangeOpt : function onPhaseChange(param) {};
    var allowPhaseChange = allowPhaseChangeOpt !== undefined ? allowPhaseChangeOpt : function allowPhaseChange(param) {
        return true;
    };
    var didEdgeSwipe = $4Q2zg.useEdgeSwipeDetector(undefined);
    var timedPhases$1 = $iv6Yc._1(didEdgeSwipe, undefined) ? $i7mYY.map(timedPhases, function(param) {
        return [
            param[0],
            0
        ];
    }) : timedPhases;
    var phases = $i7mYY.map(timedPhases$1, function(param) {
        return param[0];
    });
    var durations = $i7mYY.map(timedPhases$1, function(param) {
        return param[1];
    });
    var initialPhase = phases[0];
    var match = $g85JO.useState(function() {
        return initialPhase;
    });
    var setPhase = match[1];
    var phase = match[0];
    var total = phases.length;
    var index = $2whNH.getWithDefault($i7mYY.getIndexBy(phases, function(p) {
        return $7bjme.equal(p, phase);
    }), 0);
    var phase$1 = phases[index];
    var duration = durations[index];
    var timeout = $g85JO.useRef(undefined);
    var nextPhase = $i7mYY.get(phases, index + 1 | 0);
    var next = $2whNH.map(nextPhase, function(nextPhase) {
        return {
            phase: nextPhase,
            previousPhase: phase$1,
            currentSequence: phases,
            index: index,
            total: total
        };
    });
    var phaseChangeAllowed = $2whNH.getWithDefault($2whNH.map(next, allowPhaseChange), true);
    var nextRef = $g85JO.useRef(next);
    nextRef.current = next;
    $g85JO.useLayoutEffect(function() {
        if (total !== 1 || duration !== 0) ;
        else $iv6Yc._1(onPhaseChange, {
            phase: phase$1,
            previousPhase: phase$1,
            currentSequence: phases,
            index: index,
            total: total
        });
    }, [
        phase$1,
        duration,
        total
    ]);
    $g85JO.useLayoutEffect(function() {
        if (phaseChangeAllowed) {
            $2whNH.map(timeout.current, function(prim) {
                clearTimeout(prim);
            });
            timeout.current = $loT9g.some(setTimeout(function(param) {
                var next = nextRef.current;
                if (next !== undefined) {
                    $iv6Yc._1(setPhase, function(param) {
                        return next.phase;
                    });
                    return $iv6Yc._1(onPhaseChange, next);
                }
            }, duration));
        }
    }, [
        nextPhase,
        phaseChangeAllowed
    ]);
    return [
        phase$1,
        duration
    ];
}
function $e10a5edc54bb3b9f$export$2a301f386223225(length, duration, isOpen) {
    var wasOpen = $3QSSt.usePreviousDistinct(isOpen);
    var durationPerItem = $d8lRc.div(duration, length);
    var phases = wasOpen ? isOpen ? [
        [
            length - 1 | 0,
            0
        ]
    ] : $i7mYY.makeBy(length, function(i) {
        return [
            length - i | 0,
            durationPerItem
        ];
    }) : isOpen ? $i7mYY.makeBy(length, function(i) {
        return [
            i,
            durationPerItem
        ];
    }) : [
        [
            0,
            0
        ]
    ];
    return $e10a5edc54bb3b9f$export$574cda3fe44b1d9e(undefined, undefined, phases)[0];
}
 /* react Not a pure module */ 
});


parcelRegister("kPwXH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f2a22399d2320f01$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $lPfnp = parcelRequire("lPfnp");
function $f2a22399d2320f01$var$RectToRectTransition(Props) {
    var largeContainer = Props.largeContainer;
    var smallContainer = Props.smallContainer;
    var naturalSize = Props.naturalSize;
    var smallFitRule = Props.smallFitRule;
    var largeFitRule = Props.largeFitRule;
    var duration = Props.duration;
    var render = Props.render;
    var largeFit = $lPfnp.fitAndPosition({
        width: largeContainer.width,
        height: largeContainer.height
    }, naturalSize, largeFitRule);
    var render2 = function render2(sx, sy, tx, ty, invSx, invSy) {
        var transitionDuration = duration === 0 ? undefined : "" + String(duration) + "ms";
        var outerTransform = $ezf3v.translateAndScale(tx, ty, sx, sy);
        var innerTransform = $ezf3v.scale(invSx, invSy);
        var scaleUp = 1.0 / $81N94.float_max(sx * invSx, sy * invSy);
        var tmp = {
            height: "" + String(largeFit.height) + "px",
            width: "" + String(largeFit.width) + "px",
            transform: outerTransform,
            transformOrigin: "top left"
        };
        if (transitionDuration !== undefined) tmp.transitionDuration = transitionDuration;
        var tmp$1 = {
            height: "" + String(largeFit.height) + "px",
            width: "" + String(largeFit.width) + "px",
            transform: innerTransform
        };
        if (transitionDuration !== undefined) tmp$1.transitionDuration = transitionDuration;
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("pointer-events-none absolute inset-0 flex items-center justify-center")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0 pointer-events-auto ease-fastoutslow overflow-hidden transition-transform"),
            style: tmp
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("ease-fastoutslow transition-transform flex items-center"),
            style: tmp$1
        }, $iv6Yc._1(render, scaleUp))));
    };
    if (smallContainer === undefined) return render2(1.0, 1.0, 0, 0, 1.0, 1.0);
    var smallFit = $lPfnp.fitAndPosition({
        width: smallContainer.width,
        height: smallContainer.height
    }, naturalSize, smallFitRule);
    var sx = smallContainer.width / largeFit.width;
    var sy = smallContainer.height / largeFit.height;
    var tx = (smallContainer.x - largeContainer.x | 0) - largeFit.x | 0;
    var ty = (smallContainer.y - largeContainer.y | 0) - largeFit.y | 0;
    var invSx = smallFit.width / smallContainer.width;
    var invSy = smallFit.height / smallContainer.height;
    return render2(sx, sy, tx, ty, invSx, invSy);
}
$f2a22399d2320f01$var$RectToRectTransition.displayName = "RectToRectTransition";
var $f2a22399d2320f01$export$dd44f18ab656f3bb = $f2a22399d2320f01$var$RectToRectTransition;
 /* react Not a pure module */ 
});

parcelRegister("7dbcp", function(module, exports) {

$parcel$export(module.exports, "makeMediaChildFromMedia", function () { return $54026f371d021c2c$export$ed52efac16f87fe2; });
$parcel$export(module.exports, "makeMediaFromMediaChild", function () { return $54026f371d021c2c$export$6ac4792fa679703; });
$parcel$export(module.exports, "makeMediaFromCategory", function () { return $54026f371d021c2c$export$107903263c13b9d8; });
$parcel$export(module.exports, "productsInMedia", function () { return $54026f371d021c2c$export$e15c4c02062da8fd; });
$parcel$export(module.exports, "productVariantsInMedia", function () { return $54026f371d021c2c$export$465b68972e253a6b; });
$parcel$export(module.exports, "mediaById", function () { return $54026f371d021c2c$export$3d9034b8b19dc16f; });
$parcel$export(module.exports, "makePlaceholderMedia", function () { return $54026f371d021c2c$export$3413331227302280; });
$parcel$export(module.exports, "dedupById", function () { return $54026f371d021c2c$export$8ceebdef7b890e46; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $3tOK1 = parcelRequire("3tOK1");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $eFryz = parcelRequire("eFryz");
function $54026f371d021c2c$export$c0cb90bca98ca190(containerWidth, containerHeight, originalWidth, originalHeight, category) {
    var products = $1xf0g.getProducts(category);
    var imageHotspots = $1xf0g.getImageHotspots(category);
    var title = category.title;
    var title$1 = title.trim() !== "" && category.showTitle ? title : undefined;
    var description = category.description;
    var link = $1xf0g.Link.getCardFallbackLink(category);
    var match = category.card;
    var match$1;
    switch(match.TAG | 0){
        case /* ImageLinkCard */ 0:
            match$1 = [
                "image",
                match._0.imageUrl
            ];
            break;
        case /* VideoLinkCard */ 1:
            match$1 = [
                "video",
                match._0.videoUrl
            ];
            break;
        case /* ImageCard */ 2:
            match$1 = [
                "image",
                match._0.imageUrl
            ];
            break;
        case /* VideoCard */ 3:
            match$1 = [
                "video",
                match._0.videoUrl
            ];
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            match$1 = [
                "video",
                undefined
            ];
            break;
        case /* ImageDisplayCard */ 6:
            match$1 = [
                "image",
                match._0.imageUrl
            ];
            break;
        case /* VideoDisplayCard */ 7:
            match$1 = [
                "video",
                match._0.videoUrl
            ];
            break;
    }
    var kind = match$1[0];
    var overlayKind = kind === "image" && $2whNH.isSome(imageHotspots) ? "image" : "video";
    var card = category.card;
    var poster;
    switch(card.TAG | 0){
        case /* ImageLinkCard */ 0:
            poster = card._0.imageUrl;
            break;
        case /* VideoLinkCard */ 1:
            poster = card._0.fallbackImageUrl;
            break;
        case /* ImageCard */ 2:
            poster = card._0.imageUrl;
            break;
        case /* VideoCard */ 3:
            poster = card._0.fallbackImageUrl;
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            poster = undefined;
            break;
        case /* ImageDisplayCard */ 6:
            poster = card._0.imageUrl;
            break;
        case /* VideoDisplayCard */ 7:
            poster = card._0.fallbackImageUrl;
            break;
    }
    var match$2 = $1xf0g.getCategoryImageSize(category);
    var originalWidth$1 = $2whNH.getWithDefault(match$2[0], originalWidth);
    var originalHeight$1 = $2whNH.getWithDefault(match$2[1], originalHeight);
    return {
        id: category.id,
        kind: kind,
        title: title$1,
        showTitle: category.showTitle,
        description: description,
        link: link,
        overlayKind: overlayKind,
        originalWidth: originalWidth$1,
        originalHeight: originalHeight$1,
        src: $2whNH.getWithDefault(match$1[1], ""),
        fallbackImageUrl: poster,
        pins: $2whNH.getWithDefault(imageHotspots, $i7mYY.map(products, function(product) {
            return {
                id: product.productId,
                x: 0,
                y: 0,
                productId: product.productId,
                variantId: product.variantId,
                visible: true
            };
        }))
    };
}
function $54026f371d021c2c$export$ed52efac16f87fe2(media) {
    var match = media.kind;
    return {
        id: media.id,
        kind: typeof match === "object" || match !== "video" ? "image" : "video",
        title: media.title,
        showTitle: media.showTitle,
        description: media.description,
        link: media.link,
        overlayKind: media.overlayKind,
        originalWidth: media.originalWidth,
        originalHeight: media.originalHeight,
        src: media.src,
        fallbackImageUrl: media.fallbackImageUrl,
        pins: media.pins
    };
}
function $54026f371d021c2c$export$6ac4792fa679703(mediaChild) {
    var match = mediaChild.kind;
    return {
        order: 0,
        id: mediaChild.id,
        kind: match === "image" ? "image" : "video",
        title: mediaChild.title,
        showTitle: mediaChild.showTitle,
        description: mediaChild.description,
        link: mediaChild.link,
        overlayKind: mediaChild.overlayKind,
        originalWidth: mediaChild.originalWidth,
        originalHeight: mediaChild.originalHeight,
        src: mediaChild.src,
        fallbackImageUrl: mediaChild.fallbackImageUrl,
        pins: mediaChild.pins
    };
}
function $54026f371d021c2c$export$1530ca9c91ef2c22(originalWidth, originalHeight, containerWidth, containerHeight, isQuickViewStories, category) {
    var match = category.card;
    var kind;
    switch(match.TAG | 0){
        case /* VideoLinkCard */ 1:
        case /* VideoCard */ 3:
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
        case /* VideoDisplayCard */ 7:
            kind = "video";
            break;
        default:
            kind = "image";
    }
    var match$1 = category.categoryType;
    var kind$1;
    if (typeof match$1 === "number" || match$1.TAG !== /* QuickView */ 2) kind$1 = kind;
    else {
        var children = match$1._0.children;
        kind$1 = children.length !== 0 ? {
            NAME: "album",
            VAL: $i7mYY.map(children, function(param) {
                return $54026f371d021c2c$export$c0cb90bca98ca190(containerWidth, containerHeight, originalWidth, originalHeight, param);
            })
        } : isQuickViewStories ? {
            NAME: "album",
            VAL: [
                $54026f371d021c2c$export$c0cb90bca98ca190(containerWidth, containerHeight, originalWidth, originalHeight, category)
            ]
        } : kind;
    }
    if ($1xf0g.isQuickViewStoriesEnabled(category) && (kind$1 === "image" || kind$1 === "video")) return {
        NAME: "album",
        VAL: [
            $54026f371d021c2c$export$c0cb90bca98ca190($loT9g.some(containerWidth), $loT9g.some(containerHeight), originalWidth, originalHeight, category)
        ]
    };
    else return kind$1;
}
function $54026f371d021c2c$export$107903263c13b9d8(containerWidth, containerHeight, order, parentCategory, category) {
    var match = category.card;
    var mediaUrl;
    switch(match.TAG | 0){
        case /* ImageLinkCard */ 0:
            mediaUrl = match._0.imageUrl;
            break;
        case /* VideoLinkCard */ 1:
            mediaUrl = match._0.videoUrl;
            break;
        case /* ImageCard */ 2:
            mediaUrl = match._0.imageUrl;
            break;
        case /* VideoCard */ 3:
            mediaUrl = match._0.videoUrl;
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            mediaUrl = undefined;
            break;
        case /* ImageDisplayCard */ 6:
            mediaUrl = match._0.imageUrl;
            break;
        case /* VideoDisplayCard */ 7:
            mediaUrl = match._0.videoUrl;
            break;
    }
    var isQuickViewStories = $2whNH.mapWithDefault(parentCategory, false, $1xf0g.isQuickViewStoriesEnabled);
    var match$1 = $1xf0g.getCategoryImageSize(category);
    var originalWidth = $2whNH.mapWithDefault(match$1[0], 1440, function(w) {
        if (w === 0) return 1440;
        else return w;
    });
    var originalHeight = $2whNH.mapWithDefault(match$1[1], 1080, function(h) {
        if (h === 0) return 1080;
        else return h;
    });
    var kind = $54026f371d021c2c$export$1530ca9c91ef2c22(originalWidth, originalHeight, containerWidth, containerHeight, isQuickViewStories, category);
    var products = typeof kind === "object" ? $i7mYY.reduce(kind.VAL, [], function(acc, child) {
        return $i7mYY.concat(acc, $i7mYY.map(child.pins, function(pin) {
            return {
                id: pin.id,
                productId: pin.productId,
                variantId: pin.variantId
            };
        }));
    }) : kind === "placeholder" ? [] : $1xf0g.getProducts(category);
    var title = category.title;
    var title$1 = title.trim() !== "" ? title : undefined;
    var description = category.description;
    var link = $1xf0g.Link.getCardFallbackLink(category);
    var imageHotspots = typeof kind === "object" ? $i7mYY.concatMany($i7mYY.map(kind.VAL, function(media) {
        return media.pins;
    })) : kind === "placeholder" ? undefined : $1xf0g.getImageHotspots(category);
    var overlayKind = kind === "image" && $2whNH.isSome(imageHotspots) ? "image" : "video";
    var card = category.card;
    var poster;
    switch(card.TAG | 0){
        case /* ImageLinkCard */ 0:
            poster = card._0.imageUrl;
            break;
        case /* VideoLinkCard */ 1:
            poster = card._0.fallbackImageUrl;
            break;
        case /* ImageCard */ 2:
            poster = card._0.imageUrl;
            break;
        case /* VideoCard */ 3:
            poster = card._0.fallbackImageUrl;
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            poster = undefined;
            break;
        case /* ImageDisplayCard */ 6:
            poster = card._0.imageUrl;
            break;
        case /* VideoDisplayCard */ 7:
            poster = card._0.fallbackImageUrl;
            break;
    }
    var match$2 = typeof kind === "object" ? $2whNH.getWithDefault($2whNH.map($i7mYY.get(kind.VAL, 0), function(firstChild) {
        return [
            firstChild.originalWidth,
            firstChild.originalHeight
        ];
    }), [
        originalWidth,
        originalHeight
    ]) : [
        originalWidth,
        originalHeight
    ];
    return {
        order: order,
        id: category.id,
        kind: kind,
        title: title$1,
        showTitle: category.showTitle,
        description: description,
        link: link,
        overlayKind: overlayKind,
        originalWidth: match$2[0],
        originalHeight: match$2[1],
        src: $2whNH.getWithDefault(mediaUrl, ""),
        fallbackImageUrl: poster,
        pins: $2whNH.getWithDefault(imageHotspots, $i7mYY.map(products, function(product) {
            return {
                id: product.productId,
                x: 0,
                y: 0,
                productId: product.productId,
                variantId: product.variantId,
                visible: true
            };
        }))
    };
}
function $54026f371d021c2c$export$8d2b8a6beb29e379(media) {
    var match = media.kind;
    if (typeof match === "object") return $2whNH.map($i7mYY.get(match.VAL, 0), function(child) {
        return child.id;
    });
}
var $54026f371d021c2c$export$e15c4c02062da8fd = $3tOK1.mem(function(config, media) {
    return $i7mYY.keepMap(media.pins, function(pin) {
        return $7KlbQ.getProductById(config.products, pin.productId);
    });
});
var $54026f371d021c2c$export$465b68972e253a6b = $3tOK1.mem(function(hideOutOfStock, config, media, defaultVariantSelector) {
    return $i7mYY.keepMap(media.pins, function(pin) {
        return $2whNH.map($7KlbQ.getProductById(config.products, pin.productId), function(product) {
            var variant = $7KlbQ.getInitialDisplayVariant(hideOutOfStock, pin.variantId, defaultVariantSelector, product);
            return [
                product,
                variant
            ];
        });
    });
});
var $54026f371d021c2c$export$5f97f2d2dea70b0a = $3tOK1.mem(function(config, media) {
    return $i7mYY.keepMap(media.pins, function(pin) {
        return $7KlbQ.getProductById(config.products, pin.productId);
    });
});
var $54026f371d021c2c$export$f884bbd0ea1b6bbf = $3tOK1.mem(function(config, excludeMedia) {
    return $i7mYY.reduce(config.media, [], function(result, media) {
        if (media === excludeMedia) return result;
        else return $i7mYY.concat(result, $iv6Yc._2($54026f371d021c2c$export$e15c4c02062da8fd, config, media));
    });
});
var $54026f371d021c2c$export$db652dbd07d96e13 = $3tOK1.mem(function(media) {
    return $d3YYW.fromArray($i7mYY.map(media, function(m) {
        return [
            m.id,
            m
        ];
    }));
});
function $54026f371d021c2c$export$3d9034b8b19dc16f(config, id) {
    return $d3YYW.get($iv6Yc._1($54026f371d021c2c$export$db652dbd07d96e13, config.media), id);
}
function $54026f371d021c2c$export$3413331227302280(order) {
    return {
        order: order,
        id: String(order),
        kind: "placeholder",
        title: undefined,
        showTitle: false,
        description: undefined,
        link: undefined,
        overlayKind: undefined,
        originalWidth: 1440,
        originalHeight: 1080,
        src: "",
        fallbackImageUrl: undefined,
        pins: []
    };
}
function $54026f371d021c2c$export$8ceebdef7b890e46(__x) {
    return $eFryz.getUnique(__x, function(media) {
        return media.id;
    });
}
var $54026f371d021c2c$export$205274d8d0bfa3a = 1440;
var $54026f371d021c2c$export$d79532088d39d788 = 1080;
 /* productsInMedia Not a pure module */ 
});

parcelRegister("kJLmR", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $f18cc0d67611ea44$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $f18cc0d67611ea44$export$1f96ae73734a86cc(autoplay, media, mediaKind, mediaId, param) {
    var setProgressRef = $g85JO.useRef([]);
    var match = $g85JO.useState(function() {});
    var setProgressSpeed = match[1];
    var mediaId$1 = mediaId !== undefined ? mediaId : $2whNH.map(media, function(media) {
        return media.id;
    });
    var mediaKind$1 = mediaKind !== undefined ? mediaKind : $2whNH.map(media, function(media) {
        return media.kind;
    });
    $g85JO.useEffect(function() {
        var exit = 0;
        if (mediaKind$1 !== undefined && !(typeof mediaKind$1 === "object" || !(mediaKind$1 === "image" && autoplay))) $iv6Yc._1(setProgressSpeed, function(param) {
            return 5000;
        });
        else exit = 1;
        if (exit === 1) $iv6Yc._1(setProgressSpeed, function(param) {});
        $i7mYY.forEach(setProgressRef.current, function(fn) {
            $iv6Yc._1(fn, undefined);
        });
    }, [
        mediaId$1,
        mediaKind$1,
        autoplay
    ]);
    var setProgress = function setProgress(progress) {
        $i7mYY.forEach(setProgressRef.current, function(fn) {
            $iv6Yc._1(fn, $loT9g.some(progress));
        });
    };
    return [
        match[0],
        setProgress,
        setProgressRef
    ];
}
 /* react Not a pure module */ 
});

parcelRegister("1lWE3", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $0fc53e4d0d0658a4$export$ae01dedf5c052bb; });
$parcel$export(module.exports, "renderMedia", function () { return $0fc53e4d0d0658a4$export$20f76308ea74ac3d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $46rK3 = parcelRequire("46rK3");

var $7wIsS = parcelRequire("7wIsS");

var $55MCT = parcelRequire("55MCT");

var $8dLtV = parcelRequire("8dLtV");

var $7GW0c = parcelRequire("7GW0c");

var $fjGuk = parcelRequire("fjGuk");

var $gCzsf = parcelRequire("gCzsf");

var $gpCTg = parcelRequire("gpCTg");

var $hBcYV = parcelRequire("hBcYV");

var $2ZaET = parcelRequire("2ZaET");

var $kJLmR = parcelRequire("kJLmR");
function $0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause(Props) {
    var children = Props.children;
    var onPause = Props.onPause;
    var match = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$clearTimeout = match.clearTimeout;
    var $$setTimeout = match.setTimeout;
    var handleTouchStart = function handleTouchStart(param) {
        $iv6Yc._1($$clearTimeout, undefined);
        $$setTimeout(function(param) {
            $iv6Yc._1(onPause, true);
        }, 250);
    };
    var handleTouchEnd = function handleTouchEnd(param) {
        $iv6Yc._1($$clearTimeout, undefined);
        $$setTimeout(function(param) {
            $iv6Yc._1(onPause, false);
        }, 42);
    };
    var handleContextMenu = function handleContextMenu(e) {
        e.preventDefault();
    };
    var className = $ezf3v.prefix("absolute inset-0 select-none no-touch-callout");
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: className,
        onContextMenu: handleContextMenu,
        onTouchEnd: handleTouchEnd,
        onTouchStart: handleTouchStart
    }, children);
}
$0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause.displayName = "QuickViewMedia.TapToPause";
var $0fc53e4d0d0658a4$export$35dd246a963882e1 = {
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause
};
function $0fc53e4d0d0658a4$var$_getSize(element, src) {
    var width = element.videoWidth;
    var height = element.videoHeight;
    if (width === 0 && height === 0) return new Promise(function(resolve, reject) {
        setTimeout(function(param) {
            $0fc53e4d0d0658a4$var$_getSize(element, src).then(function(result) {
                resolve(result);
            });
        }, 42);
    });
    $2whNH.forEach($loT9g.nullable_to_opt(element.parentElement), function(parent) {
        parent.removeChild(element);
    });
    return Promise.resolve([
        src,
        width,
        height
    ]);
}
function $0fc53e4d0d0658a4$var$getSize(src) {
    return new Promise(function(resolve, reject) {
        var element = document.createElement("video");
        element.setAttribute("src", src);
        element.setAttribute("preload", "metadata");
        $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
            param.appendChild(element);
        });
        $0fc53e4d0d0658a4$var$_getSize(element, src).then(function(result) {
            resolve(result);
        });
    });
}
function $0fc53e4d0d0658a4$var$QuickViewMedia$Video(Props) {
    var src = Props.src;
    var fwdRef = Props.fwdRef;
    var isPaused = Props.isPaused;
    var onReady = Props.onReady;
    var poster = Props.poster;
    var onTimeChange = Props.onTimeChange;
    var initialTime = Props.initialTime;
    var muted = Props.muted;
    var onEnded = Props.onEnded;
    var loopOpt = Props.loop;
    var controlsOpt = Props.controls;
    var objectFit = Props.objectFit;
    var onMute = Props.onMute;
    var mediaIndexOpt = Props.mediaIndex;
    var activeMediaIndexOpt = Props.activeMediaIndex;
    var loop = loopOpt !== undefined ? loopOpt : true;
    var controls = controlsOpt !== undefined ? controlsOpt : false;
    var mediaIndex = mediaIndexOpt !== undefined ? mediaIndexOpt : 0;
    var activeMediaIndex = activeMediaIndexOpt !== undefined ? activeMediaIndexOpt : 0;
    var isPaused$1 = isPaused || mediaIndex !== activeMediaIndex;
    var ref = $g85JO.useRef(null);
    var ref$1 = fwdRef !== undefined ? fwdRef : ref;
    var pause = function pause(param) {
        $2whNH.forEach($loT9g.nullable_to_opt(ref$1.current), function(e) {
            e.pause();
        });
    };
    var handlePause = function handlePause(pause) {
        $2whNH.forEach($loT9g.nullable_to_opt(ref$1.current), function(element) {
            var pause$1 = pause || $2whNH.getWithDefault($loT9g.nullable_to_opt(element.getAttribute("class")), "").includes("QVTW__video-paused");
            if (pause$1) element.pause();
            else element.play();
        });
    };
    var play = $g85JO.useCallback(function(param) {
        $2whNH.map($loT9g.nullable_to_opt(ref$1.current), function(el) {
            return $fjGuk.playWithRetries(onMute, el);
        });
    }, [
        src
    ]);
    var onCanPlay = function onCanPlay(param) {
        if (isPaused$1) return;
        else {
            $iv6Yc._1(play, undefined);
            return $iv6Yc._1(onReady, undefined);
        }
    };
    var onEnded$1 = $2whNH.map(onEnded, function(fn, param) {
        $iv6Yc._1(fn, undefined);
    });
    $g85JO.useEffect(function() {
        if (isPaused$1) pause(undefined);
        else onCanPlay(undefined);
    }, [
        isPaused$1
    ]);
    var match = $46rK3.Hls.isHls(src);
    var match$1 = Math.abs(mediaIndex - activeMediaIndex | 0) < 2;
    var tmp;
    var exit = 0;
    if (match) {
        if (match$1) exit = 1;
        else tmp = null;
    } else if (isPaused$1) tmp = null;
    else exit = 1;
    if (exit === 1) {
        var tmp$1 = {
            src: src,
            controls: controls,
            loop: loop,
            width: "100%",
            height: "100%",
            videoRef: ref$1,
            onCanPlay: onCanPlay,
            onLoadedMetadata: onCanPlay,
            position: "absolute",
            className: isPaused$1 ? $ezf3v.prefix("video-paused") : "",
            key: src
        };
        if (muted !== undefined) tmp$1.muted = $loT9g.valFromOption(muted);
        if (poster !== undefined) tmp$1.poster = $loT9g.valFromOption(poster);
        if (onEnded$1 !== undefined) tmp$1.onEnded = $loT9g.valFromOption(onEnded$1);
        if (objectFit !== undefined) tmp$1.objectFit = $loT9g.valFromOption(objectFit);
        if (onTimeChange !== undefined) tmp$1.onTimeChange = $loT9g.valFromOption(onTimeChange);
        if (initialTime !== undefined) tmp$1.initialTime = $loT9g.valFromOption(initialTime);
        tmp = /*#__PURE__*/ $g85JO.createElement($46rK3.make, tmp$1);
    }
    return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause, {
        children: null,
        onPause: handlePause
    }, poster !== undefined ? /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
        src: poster,
        fit: objectFit === "contain" ? /* Contain */ 2 : /* Cover */ 1,
        priority: 0
    }) : null, tmp);
}
$0fc53e4d0d0658a4$var$QuickViewMedia$Video.displayName = "QuickViewMedia.Video";
var $0fc53e4d0d0658a4$export$ae01dedf5c052bb = {
    _getSize: $0fc53e4d0d0658a4$var$_getSize,
    getSize: $0fc53e4d0d0658a4$var$getSize,
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$Video
};
function $0fc53e4d0d0658a4$var$QuickViewMedia$Image(Props) {
    var src = Props.src;
    var alt = Props.alt;
    var onReady = Props.onReady;
    var onPauseAutoplay = Props.onPauseAutoplay;
    return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause, {
        children: /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
            src: src,
            fit: /* Cover */ 1,
            alt: alt,
            priority: 0,
            onLoad: function onLoad($$event) {
                $iv6Yc._1(onReady, $$event);
            }
        }),
        onPause: onPauseAutoplay
    });
}
$0fc53e4d0d0658a4$var$QuickViewMedia$Image.displayName = "QuickViewMedia.Image";
var $0fc53e4d0d0658a4$export$3105334b5e06e972 = {
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$Image
};
function $0fc53e4d0d0658a4$var$QuickViewMedia$Album$AlbumBrowser(Props) {
    var index = Props.index;
    var total = Props.total;
    var media = Props.media;
    var allAlbumMedia = Props.allAlbumMedia;
    var onChangeIndex = Props.onChangeIndex;
    var children = Props.children;
    var isMobile = Props.isMobile;
    var isStories = Props.isStories;
    var isPaused = Props.isPaused;
    var canGoNext = Props.canGoNext;
    var canGoPrevious = Props.canGoPrevious;
    var overlay = Props.overlay;
    var autoplay = Props.autoplay;
    var autoplayPaused = Props.autoplayPaused;
    var progress = Props.progress;
    var progressSpeed = Props.progressSpeed;
    var setProgressRef = Props.setProgressRef;
    var onPauseAutoplay = Props.onPauseAutoplay;
    var className = $ezf3v.prefix("absolute inset-0 select-none transform");
    var nextIcon = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-1/2 transform -translate-y-1/2 right-3 rounded-full w-12 h-12 bg-white opacity-50 group-1-hover:opacity-80 text-black flex items-center justify-center transform rotate-180")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {}));
    var prevIcon = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-1/2 transform -translate-y-1/2 left-3 rounded-full w-12 h-12 bg-white opacity-50 group-1-hover:opacity-80 text-black flex items-center justify-center")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {}));
    var goNext = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: canGoNext,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "qv-album-next",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("group-1 absolute top-0 right-0 w-3/4 h-full cursor-pointer no-touch-highlight"),
                onClick: function onClick(param) {
                    $iv6Yc._1(onChangeIndex, index + 1 | 0);
                }
            }, /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause, {
                children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: !isMobile,
                    children: nextIcon
                }),
                onPause: onPauseAutoplay
            }))
        })
    });
    var goPrevious = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: canGoPrevious,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "qv-album-previous",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("group-1 absolute top-0 left-0 w-1/4 h-full cursor-pointer no-touch-highlight"),
                onClick: function onClick(param) {
                    $iv6Yc._1(onChangeIndex, index - 1 | 0);
                }
            }, /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$TapToPause, {
                children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: !isMobile,
                    children: prevIcon
                }),
                onPause: onPauseAutoplay
            }))
        })
    });
    var tmp = {
        index: index,
        total: total,
        onClick: onChangeIndex,
        align: isStories ? "top" : isMobile ? {
            NAME: "arbBottom",
            VAL: 36
        } : "bottom",
        style: isStories ? "line" : "circle",
        gradient: true,
        dataTestId: "qv-album-tabs"
    };
    if (autoplay !== undefined) tmp.autoplay = $loT9g.valFromOption(autoplay);
    if (autoplayPaused !== undefined) tmp.autoplayPaused = $loT9g.valFromOption(autoplayPaused);
    if (progress !== undefined) tmp.progress = progress;
    if (progressSpeed !== undefined) tmp.progressSpeed = progressSpeed;
    if (setProgressRef !== undefined) tmp.setProgressRef = $loT9g.valFromOption(setProgressRef);
    var tmp$1 = isMobile ? "full" : undefined;
    if (tmp$1 !== undefined) tmp.size = $loT9g.valFromOption(tmp$1);
    var tabs = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("fixed top-0 left-0 w-full h-full pointer-events-none")
    }, /*#__PURE__*/ $g85JO.createElement($gpCTg.make, tmp));
    var imageCache = $i7mYY.map(allAlbumMedia, function(media) {
        var imgUrl = media.fallbackImageUrl;
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("opacity-0 pointer-events-none absolute inset-0")
        }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
            src: imgUrl !== undefined ? imgUrl : media.src,
            fit: /* Contain */ 2,
            alt: $2whNH.getWithDefault(media.title, "Image foreground"),
            priority: 1
        }));
    });
    var imgUrl = media.fallbackImageUrl;
    var backdrop = /*#__PURE__*/ $g85JO.createElement($55MCT.ColorOverlay.make, {
        src: imgUrl !== undefined ? imgUrl : media.src
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: className
    }, backdrop, children, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !isPaused,
        children: null
    }, goNext, goPrevious, overlay, tabs, imageCache));
}
$0fc53e4d0d0658a4$var$QuickViewMedia$Album$AlbumBrowser.displayName = "QuickViewMedia.Album.AlbumBrowser";
var $0fc53e4d0d0658a4$var$AlbumBrowser = {
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$Album$AlbumBrowser
};
function $0fc53e4d0d0658a4$var$QuickViewMedia$Album(Props) {
    var allMedia = Props.allMedia;
    var media = Props.media;
    var mediaChildren = Props.mediaChildren;
    var isPaused = Props.isPaused;
    var isMobile = Props.isMobile;
    var isStories = Props.isStories;
    var initialTime = Props.initialTime;
    var muted = Props.muted;
    var controls = Props.controls;
    var shouldAutoplay = Props.shouldAutoplay;
    var renderOverlay = Props.renderOverlay;
    var goToPrevSlide = Props.goToPrevSlide;
    var goToNextSlide = Props.goToNextSlide;
    var onReady = Props.onReady;
    var onPauseAutoplay = Props.onPauseAutoplay;
    var onAlbumMediaChange = Props.onAlbumMediaChange;
    var onMute = Props.onMute;
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var match$1 = $g85JO.useState(function() {
        return 0;
    });
    var setLastIndex = match$1[1];
    var lastIndex = match$1[0];
    var loopCarousel = !isStories;
    var curAlbumIndex;
    if (typeof route === "number" || route.TAG !== /* QuickView */ 3) curAlbumIndex = lastIndex;
    else {
        var albumId = route._0.albumId;
        curAlbumIndex = $2whNH.getWithDefault($i7mYY.getIndexBy(mediaChildren, function(media) {
            return $7bjme.equal(media.id, albumId);
        }), lastIndex);
    }
    var curMediaIndex = $2whNH.getWithDefault($i7mYY.getIndexBy(allMedia, function(media0) {
        return media0.id === media.id;
    }), 0);
    var setIndex = function setIndex(nextIndex) {
        $iv6Yc._1(setLastIndex, function(param) {
            return nextIndex;
        });
        var mediaByIndex = $i7mYY.get(mediaChildren, nextIndex);
        var currentRoute;
        currentRoute = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0;
        if (currentRoute !== undefined) return $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* QuickView */ 3,
            _0: {
                mediaId: currentRoute.mediaId,
                mediaParentId: currentRoute.mediaParentId,
                albumId: $2whNH.map(mediaByIndex, function(media) {
                    return media.id;
                }),
                productId: currentRoute.productId,
                relatedMediaProductIds: currentRoute.relatedMediaProductIds,
                relatedMediaCategoryId: currentRoute.relatedMediaCategoryId,
                variantId: currentRoute.variantId,
                panelClosed: currentRoute.panelClosed,
                zoomedPhotoIndex: currentRoute.zoomedPhotoIndex,
                time: currentRoute.time
            }
        });
    };
    var totalAlbumItems = mediaChildren.length;
    var mediaChild = $i7mYY.get(mediaChildren, curAlbumIndex);
    var match$2 = $g85JO.useState(function() {
        return {};
    });
    var setIsReadyMap = match$2[1];
    var isReadyMap = match$2[0];
    var isReady = $2whNH.getWithDefault($2whNH.flatMap(mediaChild, function(mediaChild) {
        return $d3YYW.get(isReadyMap, mediaChild.id);
    }), false);
    var shouldAutoplay$1 = shouldAutoplay && !isPaused && isReady;
    var onReady$1 = function onReady$1($$event) {
        $iv6Yc._1(onReady, $$event);
        $iv6Yc._1(setIsReadyMap, function(dict) {
            if (mediaChild === undefined) return dict;
            var key = mediaChild.id;
            var value = $$event !== undefined ? $$event.imageSize.width >= $$event.width && $$event.imageSize.height >= $$event.height : mediaChild.kind === "video";
            return $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(dict), [
                [
                    key,
                    value
                ]
            ]));
        });
    };
    var match$3 = $kJLmR.use(shouldAutoplay$1, undefined, $2whNH.map(mediaChild, function(media) {
        var match = media.kind;
        if (match === "image") return "image";
        else return "video";
    }), $2whNH.map(mediaChild, function(media) {
        return media.id;
    }), undefined);
    var setProgress = match$3[1];
    var goToNextMedia = function goToNextMedia(param) {
        if (curAlbumIndex >= (totalAlbumItems - 1 | 0)) return $iv6Yc._1(goToNextSlide, undefined);
        else if (curAlbumIndex < (totalAlbumItems - 1 | 0)) return setIndex(curAlbumIndex + 1 | 0);
        else if (curAlbumIndex < 0) return setIndex(0);
        else return;
    };
    var autoplayTimerRef = $g85JO.useRef(undefined);
    $g85JO.useEffect(function() {
        var $$clearTimeout$1 = function $$clearTimeout$1(param) {
            var id = autoplayTimerRef.current;
            if (id !== undefined) {
                clearTimeout($loT9g.valFromOption(id));
                return;
            }
        };
        $$clearTimeout$1(undefined);
        if (shouldAutoplay$1 && mediaChild !== undefined && mediaChild.kind === "image") autoplayTimerRef.current = $loT9g.some(setTimeout(goToNextMedia, 5000));
        return function(param) {
            $$clearTimeout$1(undefined);
        };
    }, [
        curAlbumIndex,
        mediaChild,
        shouldAutoplay$1
    ]);
    var handleVideoTimeChange = function handleVideoTimeChange(time, duration) {
        var progress = Math.round(time / duration * 100) | 0;
        if (progress === 100) {
            if (shouldAutoplay$1) return goToNextMedia(undefined);
            else return;
        } else return $iv6Yc._1(setProgress, progress);
    };
    var videoRef = $g85JO.useRef(null);
    var onPauseAutoplay$1 = function onPauseAutoplay$1(pause) {
        $iv6Yc._1(onPauseAutoplay, pause);
        if (mediaChild !== undefined && mediaChild.kind === "video") return $2whNH.forEach($loT9g.nullable_to_opt(videoRef.current), function(e) {
            if (pause) e.pause();
            else e.play();
        });
    };
    var mediaElement = $g85JO.useMemo(function() {
        if (mediaChild === undefined) return null;
        if (mediaChild.kind === "image") return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Image, {
            src: mediaChild.src,
            alt: $2whNH.getWithDefault(mediaChild.title, "Image media"),
            onReady: onReady$1,
            onPauseAutoplay: onPauseAutoplay$1
        });
        if (mediaChild.kind !== "video") return null;
        var poster = mediaChild.fallbackImageUrl;
        var tmp = {
            src: mediaChild.src,
            fwdRef: videoRef,
            isPaused: isPaused,
            onReady: onReady$1,
            onTimeChange: handleVideoTimeChange,
            initialTime: initialTime,
            muted: muted,
            loop: !shouldAutoplay$1,
            onMute: onMute
        };
        if (poster !== undefined) tmp.poster = $loT9g.valFromOption(poster);
        return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Video, tmp);
    }, [
        mediaChild,
        isPaused,
        shouldAutoplay$1,
        muted
    ]);
    $g85JO.useEffect(function() {
        if (isPaused) ;
        else $2whNH.forEach(mediaChild, onAlbumMediaChange);
    }, [
        mediaChild
    ]);
    var handleIndexChange = function handleIndexChange(newIndex) {
        if (loopCarousel) {
            if (newIndex < 0) return setIndex(totalAlbumItems - 1 | 0);
            else if (newIndex >= totalAlbumItems) return setIndex(0);
            else return setIndex(newIndex);
        } else if (newIndex < 0) return $iv6Yc._1(goToPrevSlide, undefined);
        else if (newIndex >= totalAlbumItems) return goToNextMedia(undefined);
        else return setIndex(newIndex);
    };
    var overlay = mediaChild !== undefined ? $iv6Yc._1(renderOverlay, mediaChild) : null;
    var canGoNext = curAlbumIndex < (totalAlbumItems - 1 | 0) || curMediaIndex < (allMedia.length - 1 | 0) || loopCarousel;
    var canGoPrevious = curAlbumIndex > 0 || curMediaIndex > 0 || loopCarousel;
    if (!controls) return mediaElement;
    var tmp = {
        index: curAlbumIndex,
        total: totalAlbumItems,
        media: media,
        allAlbumMedia: mediaChildren,
        onChangeIndex: handleIndexChange,
        children: mediaElement,
        isMobile: isMobile,
        isStories: isStories,
        isPaused: isPaused,
        canGoNext: canGoNext,
        canGoPrevious: canGoPrevious,
        overlay: overlay,
        autoplay: shouldAutoplay$1,
        autoplayPaused: false,
        setProgressRef: match$3[2],
        onPauseAutoplay: onPauseAutoplay$1
    };
    var tmp$1 = match$3[0];
    if (tmp$1 !== undefined) tmp.progressSpeed = $loT9g.valFromOption(tmp$1);
    return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Album$AlbumBrowser, tmp);
}
$0fc53e4d0d0658a4$var$QuickViewMedia$Album.displayName = "QuickViewMedia.Album";
var $0fc53e4d0d0658a4$export$2ee11c425a1bd6c1 = {
    AlbumBrowser: $0fc53e4d0d0658a4$var$AlbumBrowser,
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$Album
};
function $0fc53e4d0d0658a4$var$QuickViewMedia$MediaWrapper(Props) {
    var media = Props.media;
    var children = Props.children;
    var className = $ezf3v.prefix("absolute inset-0 select-none bg-white");
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "qv-media",
        dataId: String(media.order),
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: className
        }, children)
    });
}
$0fc53e4d0d0658a4$var$QuickViewMedia$MediaWrapper.displayName = "QuickViewMedia.MediaWrapper";
var $0fc53e4d0d0658a4$export$542000db99cecf28 = {
    make: $0fc53e4d0d0658a4$var$QuickViewMedia$MediaWrapper
};
function $0fc53e4d0d0658a4$export$20f76308ea74ac3d(allMedia, media, mediaIndex, activeMediaIndex, isPaused, isMobile, isStories, initialTime, onTimeChange, shouldAutoplay, muted, controls, goToSlide, onReady, onMute, onPauseAutoplay, onAlbumMediaChange, renderOverlay, param) {
    var goToNextSlide = function goToNextSlide(param) {
        var nextIndex = activeMediaIndex + 1 | 0;
        if (nextIndex < allMedia.length) return $iv6Yc._1(goToSlide, nextIndex);
    };
    var goToPrevSlide = function goToPrevSlide(param) {
        var previousIndex = activeMediaIndex - 1 | 0;
        if (previousIndex >= 0) return $iv6Yc._1(goToSlide, previousIndex);
    };
    var match = media.kind;
    var tmp;
    if (typeof match === "object") tmp = /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Album, {
        allMedia: allMedia,
        media: media,
        mediaChildren: match.VAL,
        isPaused: isPaused,
        isMobile: isMobile,
        isStories: isStories,
        initialTime: initialTime,
        muted: muted,
        controls: controls,
        shouldAutoplay: shouldAutoplay,
        renderOverlay: renderOverlay,
        goToPrevSlide: goToPrevSlide,
        goToNextSlide: goToNextSlide,
        onReady: onReady,
        onPauseAutoplay: onPauseAutoplay,
        onTimeChange: onTimeChange,
        onAlbumMediaChange: onAlbumMediaChange,
        onMute: onMute
    });
    else if (match === "video") {
        var tmp$1 = {
            src: media.src,
            isPaused: isPaused,
            onReady: onReady,
            onTimeChange: onTimeChange,
            initialTime: initialTime,
            muted: muted,
            onEnded: goToNextSlide,
            loop: !shouldAutoplay,
            onMute: onMute,
            mediaIndex: mediaIndex,
            activeMediaIndex: activeMediaIndex
        };
        if (media.fallbackImageUrl !== undefined) tmp$1.poster = $loT9g.valFromOption(media.fallbackImageUrl);
        tmp = /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Video, tmp$1);
    } else tmp = match === "placeholder" ? null : match === "image" ? /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$Image, {
        src: media.src,
        alt: $2whNH.getWithDefault(media.title, "Image media"),
        onReady: onReady,
        onPauseAutoplay: onPauseAutoplay
    }) : /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
        url: media.src
    });
    return /*#__PURE__*/ $g85JO.createElement($0fc53e4d0d0658a4$var$QuickViewMedia$MediaWrapper, {
        isPaused: isPaused,
        isMobile: isMobile,
        goToSlide: goToSlide,
        media: media,
        activeMediaIndex: activeMediaIndex,
        children: tmp
    });
}
 /* react Not a pure module */ 
});

})();
//# sourceMappingURL=QuickViewOverlay.bs.3b0fd047.js.map
